import React, { useContext, useState } from 'react';
import SelectPackage from '../SelectPackage/SelectPackage';
import { useMediaQuery } from 'react-responsive';
import { CabTypesAvailableForRent } from '../../pages/runtime-typechecker';
import './RentalCabs.css';
import { Context } from '../../AppContext';
import { CASE_CAB_CARD } from '../../constants/omniture';
import { getCarTypeForDisplay } from '../../utils/stringUtils';
import { setDateAsDatePlusN } from '../../utils/timeUtils';
import queryString from 'query-string';
import { isWebView } from '../../utils/commonUtils';

type RentalCabPriceProps = {
  h2: string;
  cityName: string;
  operatorName?: string;
  data: CabTypesAvailableForRent;
};

type RentalCabPriceRowsProps = {
  cityName: string;
  operatorName?: string;
  data: CabTypesAvailableForRent;
  isMobileDevice: boolean;
  selectedPackage: number;
};

const RentalCabPrice = ({
  h2,
  cityName,
  operatorName,
  data
}: RentalCabPriceProps) => {
  const { trackTemplateEvent } = useContext(Context);
  const packages =
    data && data.packages && data.packages.length > 0
      ? data.packages.map(p => p.duration + ' ' + p.distance)
      : [];
  const [selectedPackage, setPackage] = useState(0);

  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });

  const onPackageSelect = (idx: number) => {
    setPackage(idx);
    trackTemplateEvent(`Cab_SEO_${packages[idx].replace(/\s/g, '')}_Select`);
  };

  return (
    <section className="visibilityAuto">
      <h2>{h2}</h2>
      <div className="cabTypeWrap">
        <div className="selectPackageWrap">
          <div className="selectPackageTitle">
            <p className="selectPackageHeading">Select package</p>
            <p className="selectPackageSuheading">Basis duration & kms</p>
          </div>
          <SelectPackage
            packages={packages}
            selectedPackage={selectedPackage}
            onPackageSelect={onPackageSelect}
          />
        </div>
        <RentalCabPriceRows
          isMobileDevice={isMobileDevice}
          cityName={cityName}
          operatorName={operatorName}
          data={data}
          selectedPackage={selectedPackage}
        />
      </div>
    </section>
  );
};
export const RentalCabPriceRows = ({
  isMobileDevice,
  cityName,
  operatorName,
  data,
  selectedPackage
}: RentalCabPriceRowsProps) => {
  const { omniUrlArgs, trackTemplateEvent } = useContext(Context);
  const landingUrl = `https://www.makemytrip.com/cabs?${omniUrlArgs}${CASE_CAB_CARD}`;
  const trackClick = (
    type: string,
    trackTemplateEvent: (eventWithValToTrack: string) => void
  ) => {
    trackTemplateEvent(`Cab_SEO_${type}_Rental_Book_Click`);
  };
  const redirect = (listingUrl, omniUrlArgs) => {
    const landingUrl = `https://www.makemytrip.com/cabs?${omniUrlArgs}${CASE_CAB_CARD}`;
    const webViewlandingUrl = `mmyt://react/?page=cabs&deeplink=true&tripType=HR&${omniUrlArgs}${CASE_CAB_CARD}`;

    let redirectionUrl = isWebView() ? webViewlandingUrl : landingUrl;

    if (listingUrl) {
      const query = queryString.parseUrl(listingUrl).query;
      const fromCity = query['fromCity'];
      const webViewlistingUrl = `${setDateAsDatePlusN(
        `mmyt://react/?page=cabsListing&deeplink=true&from=${fromCity}&tripType=HR&startDate=21-08-2020&${omniUrlArgs}${CASE_CAB_CARD}`
      )}`;

      redirectionUrl = isWebView()
        ? webViewlistingUrl
        : `${setDateAsDatePlusN(listingUrl)}&${omniUrlArgs}${CASE_CAB_CARD}`;
    }
    window.location = Object(redirectionUrl);
  };
  return (
    <div className="cabTypeWrap">
      <table
        style={{ width: '100%', border: '1px solid #cecece' }}
        className={` cabTypeDetails RentaCabsBorder`}
      >
        <>
          {isMobileDevice ? (
            <tr style={{ textAlign: 'left' }} className="cabTypeMobHead">
              <th className="cabTypeCol">
                {operatorName
                  ? `${operatorName} Types in ${cityName}`
                  : `Cab Types`}
              </th>
              <th className="cabTypeCol">Seats & bags</th>
              <th className="cabTypeCol">Price</th>
              {/* <th className="cabTypeCol viewDtl"> &nbsp;</th> */}
            </tr>
          ) : (
            <thead>
              <tr style={{ textAlign: 'left' }} className="cabTypeHead">
                <th className="cabTypeCol">
                  {operatorName
                    ? `${operatorName} Types in ${cityName}`
                    : `Cab Types`}
                </th>
                <th className="cabTypeCol">Seats & bags</th>
                <th className="cabTypeCol">Price</th>
                <th className="cabTypeCol viewDtl flexGrow1_2"> &nbsp;</th>
              </tr>
            </thead>
          )}
        </>
        <tbody>
          {data &&
            data.packages &&
            data.packages[selectedPackage].cab_list.map((item, index) => (
              <tr
                key={index}
                className={index === 0 ? 'cabTypeRow noBdr' : 'cabTypeRow'}
              >
                {isMobileDevice ? (
                  <a
                    onClick={e => {
                      e.preventDefault();
                      trackClick(
                        item && item.type ? item.type?.replace(/_/, ' ') : '',
                        trackTemplateEvent
                      );
                      redirect(item.redirection_url, omniUrlArgs);
                    }}
                    href={
                      item.redirection_url ? item.redirection_url : landingUrl
                    }
                  >
                    <td
                      style={{ border: '1px solid #cecece' }}
                      className="cabTypeCol"
                    >
                      <div className="makeFlex">
                        <span className="carImgWrap">
                          <img
                            className="lazyload"
                            data-src={item?.image || ''}
                            alt={`${item.type} image`}
                          />
                        </span>
                        <div>
                          <p className="cabTypeRoute">{item.vehicle_model}</p>
                          <p className="cabTimeDis">
                            {getCarTypeForDisplay(item.type)}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td
                      style={{ border: '1px solid #cecece' }}
                      className="cabTypeCol seatBagWrap"
                    >
                      {item && item.utilities && (
                        <span className="seatBagItems">
                          <span className="seatIocn cabSeoSprite"></span>{' '}
                          {item.utilities[1][0]} Seats
                        </span>
                      )}
                      {item && item.utilities && (
                        <span className="seatBagItems">
                          <span className="bagsIocn cabSeoSprite"></span>{' '}
                          {item.utilities[2][0]} Bag(s)
                        </span>
                      )}
                      {item && item.utilities && item.utilities.includes('AC') && (
                        <span className="seatBagItems">
                          <span className="acIocn cabSeoSprite"></span> AC
                        </span>
                      )}
                    </td>
                    <td
                      style={{ border: '1px solid #cecece' }}
                      className="cabTypeCol"
                    >
                      <p className="cabTypePrice">₹{item.total_amount}</p>
                      <p className="cabTypeOnwards">
                        <span className="hiddenDesktop">onwards</span>
                        <span className="hiddenMobile">
                          {item.inclusive_message}
                        </span>
                      </p>
                    </td>
                    {/* <td
                      style={{ border: '1px solid #cecece' }}
                      className="cabTypeCol"
                    ></td> */}
                  </a>
                ) : (
                  <>
                    <td
                      style={{ border: '1px solid #cecece' }}
                      className="cabTypeCol"
                    >
                      <div className="makeFlex">
                        <span className="carImgWrap">
                          <img
                            className="lazyload"
                            data-src={item.image}
                            alt={`${item.type} image`}
                          />
                        </span>
                        <div>
                          <p className="cabTypeRoute">{item.vehicle_model}</p>
                          <p className="cabTimeDis">
                            {getCarTypeForDisplay(item.type)}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td
                      style={{ border: '1px solid #cecece' }}
                      className="cabTypeCol seatBagWrap"
                    >
                      {item && item.utilities && (
                        <span className="seatBagItems">
                          <span className="seatIocn cabSeoSprite"></span>{' '}
                          {item.utilities[1][0]} Seats
                        </span>
                      )}
                      {item && item.utilities && (
                        <span className="seatBagItems">
                          <span className="bagsIocn cabSeoSprite"></span>{' '}
                          {item.utilities[2][0]} Bag(s)
                        </span>
                      )}
                      {item && item.utilities && item.utilities.includes('AC') && (
                        <span className="seatBagItems">
                          <span className="acIocn cabSeoSprite"></span> AC
                        </span>
                      )}
                    </td>
                    <td
                      style={{ border: '1px solid #cecece' }}
                      className="cabTypeCol"
                    >
                      <p className="cabTypePrice">₹{item.total_amount}</p>
                      <p className="cabTypeOnwards">
                        <span className="hiddenDesktop">onwards</span>
                        <span className="hiddenMobile">
                          {item.inclusive_message}
                        </span>
                      </p>
                    </td>
                    <td
                      style={{ border: '1px solid #cecece' }}
                      className="cabTypeCol"
                    >
                      <a
                        className="viewCabBtn"
                        href={
                          item.redirection_url
                            ? item.redirection_url
                            : landingUrl
                        }
                        onClick={e => {
                          e.preventDefault();
                          trackClick(
                            item && item.type
                              ? item.type.replace(/_/, ' ')
                              : '',
                            trackTemplateEvent
                          );
                          redirect(item.redirection_url, omniUrlArgs);
                        }}
                      >
                        {' '}
                        BOOK CAB
                      </a>
                    </td>
                  </>
                )}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};
export default RentalCabPrice;
